/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit, signal} from '@angular/core';

import template from './scan-results-page.component.html';
import {AdnTranslateService} from '../../common/filters/adn-translate.service';
import {AdnCheckerService} from '../../../components/util/adn-checker.service';

@Component({
  standalone: false,
  selector: 'adn-scan-results-page',
  template
})
export class ScanResultsPageComponent implements OnInit {
  readonly bigStatuses = ['BLOCKED', 'INITIALLY_BLOCKED', 'ALLOWED'];

  hide: Record<string, boolean> = {};
  readonly loaded = signal(false);
  readonly creativeBlocks = signal<any[]>([]);
  readonly data = signal<Record<string, any>>({});
  readonly dataKeys = signal<string[]>([]);

  constructor(
    @Inject(AdnCheckerService) private readonly adnChecker: any,
    private readonly adnTranslate: AdnTranslateService
  ) {
  }

  ngOnInit(): void {
    this.doCheck();
  }

  doCheck(): void {
    this.loaded.set(false);

    this.adnChecker.scanResultsByCreative().then((data: any[]) => {
      this.creativeBlocks.set(data || []);
    });

    this.adnChecker.scanResults('BLOCKED').then((data: Record<string, any>) => {
      const results = data || {};
      this.data.set(results);
      this.dataKeys.set(Object.keys(results));
      this.loaded.set(true);
    });
  }

  translateViolation(violation: any): string {
    return this.adnTranslate.transform(violation.text, violation.code, violation.parameters);
  }

  getStatusCount(key: string, bigStatus: string): number {
    return this.data()[key]?.[bigStatus]?.length || 0;
  }
}
